import * as React from "react"
const Success = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={78}
    height={79}
    fill="none"
    {...props}
  >
    <circle cx={39} cy={39.674} r={39} fill="#08C39E" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.545}
      d="M24.818 39.673 35.454 50.31l17.727-21.273"
    />
  </svg>
)
export default Success
